import React, { useState } from "react";
import { Link } from "react-router-dom";
import { X, ChevronDown, ArrowRight } from "lucide-react";
import Logo from "@/brand/Logo";
import { SOLUTIONS, PLATFORMS } from "@/data/site";

function Section({ title, items, base, onNavigate }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="border-b border-border py-1">
      <button
        className="flex w-full items-center justify-between py-3 text-left text-base font-semibold text-cbink"
        onClick={() => setOpen((o) => !o)}
      >
        {title}
        <ChevronDown size={18} className={`transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div className="flex flex-col gap-1 pb-3">
          {items.map((it) => (
            <Link
              key={it.slug}
              to={`${base}/${it.slug}`}
              onClick={onNavigate}
              className="rounded-lg px-3 py-2 text-sm text-cbslate hover:bg-cbmist hover:text-primary"
            >
              {it.title}
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}

export default function MobileMenu({ open, onClose }) {
  return (
    <div className={`lg:hidden ${open ? "" : "pointer-events-none"}`}>
      <div
        className={`fixed inset-0 z-50 bg-cbink/40 transition-opacity ${open ? "opacity-100" : "opacity-0"}`}
        onClick={onClose}
        aria-hidden="true"
      />
      <aside
        className={`fixed right-0 top-0 z-50 flex h-full w-[86%] max-w-sm flex-col bg-white shadow-panel transition-transform duration-300 ${
          open ? "translate-x-0" : "translate-x-full"
        }`}
        aria-label="Mobile menu"
        data-testid="mobile-menu"
      >
        <div className="flex items-center justify-between border-b border-border px-5 py-4">
          <Logo size={32} />
          <button onClick={onClose} aria-label="Close menu" className="flex h-9 w-9 items-center justify-center rounded-lg border border-border">
            <X size={20} />
          </button>
        </div>
        <div className="flex-1 overflow-y-auto px-5 py-2">
          <Section title="Solutions" items={SOLUTIONS} base="/solutions" onNavigate={onClose} />
          <Section title="Platforms" items={PLATFORMS} base="/platforms" onNavigate={onClose} />
          {[
            ["Why Cloud Beaker", "/why"],
            ["Industries", "/industries"],
            ["Resources", "/resources"],
            ["Contact", "/contact"],
          ].map(([label, to]) => (
            <Link
              key={to}
              to={to}
              onClick={onClose}
              className="block border-b border-border py-4 text-base font-semibold text-cbink hover:text-primary"
            >
              {label}
            </Link>
          ))}
        </div>
        <div className="flex flex-col gap-2 border-t border-border p-5">
          <Link to="/portal" onClick={onClose} className="btn-primary w-full" data-testid="mobile-client-portal">
            Client Portal <ArrowRight size={16} />
          </Link>
        </div>
      </aside>
    </div>
  );
}
